import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Features/SD_Card/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import PrimaryBox from 'components/Web_User_Interface/1440p_Series/Features/SD_Card/PrimaryBox';
import SDTable from 'components/Web_User_Interface/1440p_Series/Features/SD_Card/sdTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Features Menü // SD Karte",
  "path": "/Web_User_Interface/1440p_Serie/Features/SD_Karte/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Wählen Sie ob Sie die SD Karte auswerfen oder Formatieren möchten und bestätigen Sie die Eingabe. Es ist immer empfohlen die SD Karte zuerst auszuwerfen, bevor Sie sie aus der Kamera entfernen. Gerade wenn die Kamera eine Aufnahme durchführt während die Stromversorgung gekappt wird, kann es zu Fehlern im Dateisystem kommen. Sollte die SD Karte beschädigt werden, wird das Betriebssystem versuchen die SD Karte zu reparieren und es kann einige Minuten dauern, bis die SD Karte wieder verfügbar ist. Sollte die SD Karte auch nach einiger Zeit noch nicht erreichbar sein, können Sie probieren die Karte zu formatieren. Sollte die Karte ausgeworfen werden, wird das Betriebssystem versuchen Sie nach einiger Zeit wieder automatisch zu mounten.",
  "image": "./WebUI_1440p_SearchThumb_Features_SD_Card.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Features_SD_Card.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title='Features Menü // SD Karte' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Wählen Sie ob Sie die SD Karte auswerfen oder Formatieren möchten und bestätigen Sie die Eingabe. Es ist immer empfohlen die SD Karte zuerst auszuwerfen, bevor Sie sie aus der Kamera entfernen. Gerade wenn die Kamera eine Aufnahme durchführt während die Stromversorgung gekappt wird, kann es zu Fehlern im Dateisystem kommen. Sollte die SD Karte beschädigt werden, wird das Betriebssystem versuchen die SD Karte zu reparieren und es kann einige Minuten dauern, bis die SD Karte wieder verfügbar ist. Sollte die SD Karte auch nach einiger Zeit noch nicht erreichbar sein, können Sie probieren die Karte zu formatieren. Sollte die Karte ausgeworfen werden, wird das Betriebssystem versuchen Sie nach einiger Zeit wieder automatisch zu mounten.' image='/images/Search/WebUI_1440p_SearchThumb_Features_SD_Card.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Features_SD_Card.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Features/SD_Card/' locationFR='/fr/Web_User_Interface/1440p_Series/Features/SD_Card/' crumbLabel="SD Card" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "features-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#features-men%C3%BC",
        "aria-label": "features menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/1ee6d20e8ee2c7da02bc81d7780346c2/c9c3a/1440p_Settings_Features_SD_Card.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "49.565217391304344%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAA7rAAAO6wFxzYGVAAAB/0lEQVQoz12SzU4TURhA+x6KQY0OtNOWIJBOofPXWsCGmbn3TmemlKqFQsUQDUGMJgZZmPiXsFBfwI26MnHryx0zMxQii5MvuYuT8+W7BV3XKRaLlEolZmdnuXP7Fq3Re/w3v1k7/sHa8U/WX/66IH0LT//g9F5w4/o1SiWdZrPJ1NQU09M3KaSiXFZE0zR0vYyIHrK5/ZTk0TijuzUi7O9kRINdBqMDOl6X2lKdet2kbjSyubRoUEjrUtI6TbtLpVxF+AFRKOmmKIEM/AwReCgZECkf3wuwzPs0VhzMhotltjBqjVw4WTctLJerBIEkThLCsIsQAiklUqp8qhDZe0yUjFhtethWLkyp1VYopKLLwkthr9cjjuMLpFIIESBUl87uW7biPTY3Nmi3bSwzFTYxUuGkMJ2ZUK8gAkGSJJkoyUpDVCYUKCUJgoBnw5Dn41U66xaNZQfbPBdeLaxW5pBCkiQxURRdiCar+77PcHvEu5NDDoYOLcfCsWxaroNhrFw9ipYdRQpFv9/PhBNRuq4UAZ7nMRyP+X72mW+HO1hmnbZr49oORm05/zZXr+z7IivLjyFzaRgjox6RkGwqxdePn/j74ZTuuo3ruLhOi3q98X/hzIyW/cfOg86l6Lyu++QEdfSF12rAWbPNq/19jvYGePYC8/cWWVxYYq46zz/5BHAq1QxE4gAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/1ee6d20e8ee2c7da02bc81d7780346c2/e4706/1440p_Settings_Features_SD_Card.avif 230w", "/de/static/1ee6d20e8ee2c7da02bc81d7780346c2/d1af7/1440p_Settings_Features_SD_Card.avif 460w", "/de/static/1ee6d20e8ee2c7da02bc81d7780346c2/7f308/1440p_Settings_Features_SD_Card.avif 920w", "/de/static/1ee6d20e8ee2c7da02bc81d7780346c2/7586f/1440p_Settings_Features_SD_Card.avif 1289w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/1ee6d20e8ee2c7da02bc81d7780346c2/a0b58/1440p_Settings_Features_SD_Card.webp 230w", "/de/static/1ee6d20e8ee2c7da02bc81d7780346c2/bc10c/1440p_Settings_Features_SD_Card.webp 460w", "/de/static/1ee6d20e8ee2c7da02bc81d7780346c2/966d8/1440p_Settings_Features_SD_Card.webp 920w", "/de/static/1ee6d20e8ee2c7da02bc81d7780346c2/501f3/1440p_Settings_Features_SD_Card.webp 1289w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/1ee6d20e8ee2c7da02bc81d7780346c2/81c8e/1440p_Settings_Features_SD_Card.png 230w", "/de/static/1ee6d20e8ee2c7da02bc81d7780346c2/08a84/1440p_Settings_Features_SD_Card.png 460w", "/de/static/1ee6d20e8ee2c7da02bc81d7780346c2/c0255/1440p_Settings_Features_SD_Card.png 920w", "/de/static/1ee6d20e8ee2c7da02bc81d7780346c2/c9c3a/1440p_Settings_Features_SD_Card.png 1289w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/1ee6d20e8ee2c7da02bc81d7780346c2/c0255/1440p_Settings_Features_SD_Card.png",
              "alt": "Web User Interface - 1440p Series - Features SD Card",
              "title": "Web User Interface - 1440p Series - Features SD Card",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h3 {...{
      "id": "das-sd-karten-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#das-sd-karten-men%C3%BC",
        "aria-label": "das sd karten menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Das SD Karten Menü`}</h3>
    <p>{`Wählen Sie ob Sie die SD Karte auswerfen oder Formatieren möchten und bestätigen Sie die Eingabe. Es ist immer empfohlen die SD Karte zuerst auszuwerfen, bevor Sie sie aus der Kamera entfernen. Gerade wenn die Kamera eine Aufnahme durchführt während die Stromversorgung gekappt wird, kann es zu Fehlern im Dateisystem kommen. Sollte die SD Karte beschädigt werden, wird das Betriebssystem versuchen die SD Karte zu reparieren und es kann einige Minuten dauern, bis die SD Karte wieder verfügbar ist. Sollte die SD Karte auch nach einiger Zeit noch nicht erreichbar sein, können Sie probieren die Karte zu formatieren. Sollte die Karte ausgeworfen werden, wird das Betriebssystem versuchen Sie nach einiger Zeit wieder automatisch zu mounten.`}</p>
    <p>{`Ein Klick auf die Ordner-Schaltfläche führt Sie zum SD-Kartenverzeichnis, in dem alle Ihre Schnappschüsse und Videos gespeichert werden. Verwenden Sie den Kamera-Admin-Login, um auf das Verzeichnis zuzugreifen. Es gibt jedoch auch bequemere Möglichkeiten, über `}<a parentName="p" {...{
        "href": "/de/Bewegungserkennung/SD_Karten_Zugriff/"
      }}>{`Software von Drittanbietern`}</a>{` auf Ihre Aufnahmen zuzugreifen oder unsere Handy App InstarVision für `}<a parentName="p" {...{
        "href": "/de/Software/iOS/InstarVision/iPhone/Recording/"
      }}>{`iPhone`}</a>{`, `}<a parentName="p" {...{
        "href": "/de/Software/iOS/InstarVision/iPad/Recording/"
      }}>{`iPad`}</a>{`, `}<a parentName="p" {...{
        "href": "/de/Software/Android/InstarVision/Recording/"
      }}>{`Android`}</a>{`, `}<a parentName="p" {...{
        "href": "/de/Software/Windows/InstarVision/Windows_Phone/Recording/"
      }}>{`Windows Phone`}</a>{` und `}<a parentName="p" {...{
        "href": "/de/Software/Windows/InstarVision/Metro/Recording/"
      }}>{`Windows Metro`}</a></p>
    <p><strong parentName="p">{`FAT32`}</strong>{`: Sollten Sie die SD Karte außerhalb der Kamera formatieren, wählen Sie bitte das FAT32 Format.`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <SDTable mdxType="SDTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PrimaryBox mdxType="PrimaryBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Klicken Sie auf `}<strong parentName="p">{`SD Karte`}</strong>{` oberhalb des Live-Videos, um den SD Card Viewer zu öffnen:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/ffab9d421f04a5ce15282b3b3a954476/00d43/1440p_Settings_Features_SD_Card_Viewer.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "76.95652173913044%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACDUlEQVQ4y52SWU/bQBRG/csKBa/B28zYsWlKQ0lIGpYkSJS0pASkEiBVCVJZXtqnvvc3nmocTBehqPTh6H4azz26vraRd8+o7oxJtseIrVPkXMaIzilx57SoBVuz3rx7Trr9EUNEAVLEiCgkDgOiwC+QcVSc6SyiCBEGBJ7N5us1jocD3u332etu0WltUH+5iu9Z2OYSxvr2LvvTa3oXl/QupvQnU3bOPtMt8hW755d0J1d0Tsb4QUi/v0evv8fx8QkXk098OBrRftNBCIntVjD6zZhvI5ebwTI3gyXuDi2+7D/jZvCcu/cm1weL3A4WmfQWCfwKjUaTarVKs9lkOBwyGo1ot9tUKhUc18VIqxn56hpJdbUgzV4gk+whqzSfkWRFk5bVajUajQatVot6vU6e51iWheM4GEIIhIiRQhSI+/p3llIShgFJkhTCMAxJ0xSlFJ7nsbCwgKsn1Bf/BS3XzVqoa5ZlRdZSXYs7Uj1NqGsp1K+pX//hjhDEQj5dqCV6Ki3UYlGuRv6nsKSc9Nf5E4RlUznN78zO/xAK1D06lw/nT1hm9bA/Ve4wiiWVULISPT7B40hEHCIiv6iBlDPiGOPtRsiPoxW+Dypkif70EjVvBUohRYTaPCQ5+ErePmHq+tx6Ae2VAEP5Fq3UZEOZuI6NbTvFHz8X28YJEhy1jhdm1JZNXpkWwbLJT/z1YGq25hxdAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/ffab9d421f04a5ce15282b3b3a954476/e4706/1440p_Settings_Features_SD_Card_Viewer.avif 230w", "/de/static/ffab9d421f04a5ce15282b3b3a954476/d1af7/1440p_Settings_Features_SD_Card_Viewer.avif 460w", "/de/static/ffab9d421f04a5ce15282b3b3a954476/7f308/1440p_Settings_Features_SD_Card_Viewer.avif 920w", "/de/static/ffab9d421f04a5ce15282b3b3a954476/445fc/1440p_Settings_Features_SD_Card_Viewer.avif 1000w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/ffab9d421f04a5ce15282b3b3a954476/a0b58/1440p_Settings_Features_SD_Card_Viewer.webp 230w", "/de/static/ffab9d421f04a5ce15282b3b3a954476/bc10c/1440p_Settings_Features_SD_Card_Viewer.webp 460w", "/de/static/ffab9d421f04a5ce15282b3b3a954476/966d8/1440p_Settings_Features_SD_Card_Viewer.webp 920w", "/de/static/ffab9d421f04a5ce15282b3b3a954476/a5d4d/1440p_Settings_Features_SD_Card_Viewer.webp 1000w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/ffab9d421f04a5ce15282b3b3a954476/81c8e/1440p_Settings_Features_SD_Card_Viewer.png 230w", "/de/static/ffab9d421f04a5ce15282b3b3a954476/08a84/1440p_Settings_Features_SD_Card_Viewer.png 460w", "/de/static/ffab9d421f04a5ce15282b3b3a954476/c0255/1440p_Settings_Features_SD_Card_Viewer.png 920w", "/de/static/ffab9d421f04a5ce15282b3b3a954476/00d43/1440p_Settings_Features_SD_Card_Viewer.png 1000w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/ffab9d421f04a5ce15282b3b3a954476/c0255/1440p_Settings_Features_SD_Card_Viewer.png",
              "alt": "Web User Interface - 1440p Series - Features SD Card",
              "title": "Web User Interface - 1440p Series - Features SD Card",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h3 {...{
      "id": "austauschen-der-sd-karte",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#austauschen-der-sd-karte",
        "aria-label": "austauschen der sd karte permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Austauschen der SD Karte`}</h3>
    <p>{`Bei den Innenkameras ist die SD Karte direkt am Gehäuse zugänglich. Bei den Außenkameras muß das Gehäuse geöffnet werden um die SD Karte zu tauschen:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/f87097cdbe37b9d3081e30c7160c7eea/d56b5/1440p_Settings_Features_SD_Card_Location.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "40%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAIAAAB2/0i6AAAACXBIWXMAAA7rAAAO6wFxzYGVAAABvUlEQVQY0y2QTW8SURSGD/APCAu3pTYaw5KdaYyxTXQWxia6qBpFZ8HHJFURNphQVkDHZFi0C1mS2CVxU1M3lsBPYAM2ITgyJDMk3M69w2TufHG1Mz7LN+fJm/cAY8xxHMuyaIDrumGCMaaUOo7juq7v+57nUdtGV1fyH/l3gKZpEN6ZprlarUzTJIQwxnRdHw6Hsix/Pzv7cX4+GAy63W6r+bl4cPDmdaZ2WON5vlKpQChQSu0AjLHneZZlTSYTRVFE8ej53pMPhcJH/u2Lvafb97a53Ycnx8epVCqXy4FhGBhjTVXn87lpmoZhUEoJIaPRaLlcttvtZ4+5ZvVTJfPqS4bPPLj/cn//uhOgWCxey4vF4tflpaqqCCFFUTzPG4/Hp19Pp9Npr9d7tLtzZ2vrdvLmtxu3mnd3su/fJTc2AKBUKgEhxLZtomkIIcMwws39fj+dTnc6nYuLn5IkFQThsFY7abXy+XwikYhGo//lcCfRdcuydF1HCIUyAMTjcY7jyuVytVrNZrPJzU0AiEQisVgMAARBAMaY7/uUUhy8bb1eM8Zms9lRgCiKUoAoivV6XZKkVkCj0fhX8BeGz0TKkJ2CegAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/f87097cdbe37b9d3081e30c7160c7eea/e4706/1440p_Settings_Features_SD_Card_Location.avif 230w", "/de/static/f87097cdbe37b9d3081e30c7160c7eea/d1af7/1440p_Settings_Features_SD_Card_Location.avif 460w", "/de/static/f87097cdbe37b9d3081e30c7160c7eea/7f308/1440p_Settings_Features_SD_Card_Location.avif 920w", "/de/static/f87097cdbe37b9d3081e30c7160c7eea/eb15d/1440p_Settings_Features_SD_Card_Location.avif 1215w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/f87097cdbe37b9d3081e30c7160c7eea/a0b58/1440p_Settings_Features_SD_Card_Location.webp 230w", "/de/static/f87097cdbe37b9d3081e30c7160c7eea/bc10c/1440p_Settings_Features_SD_Card_Location.webp 460w", "/de/static/f87097cdbe37b9d3081e30c7160c7eea/966d8/1440p_Settings_Features_SD_Card_Location.webp 920w", "/de/static/f87097cdbe37b9d3081e30c7160c7eea/34ce3/1440p_Settings_Features_SD_Card_Location.webp 1215w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/f87097cdbe37b9d3081e30c7160c7eea/81c8e/1440p_Settings_Features_SD_Card_Location.png 230w", "/de/static/f87097cdbe37b9d3081e30c7160c7eea/08a84/1440p_Settings_Features_SD_Card_Location.png 460w", "/de/static/f87097cdbe37b9d3081e30c7160c7eea/c0255/1440p_Settings_Features_SD_Card_Location.png 920w", "/de/static/f87097cdbe37b9d3081e30c7160c7eea/d56b5/1440p_Settings_Features_SD_Card_Location.png 1215w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/f87097cdbe37b9d3081e30c7160c7eea/c0255/1440p_Settings_Features_SD_Card_Location.png",
              "alt": "Web User Interface - 1440p Series - Features SD Card",
              "title": "Web User Interface - 1440p Series - Features SD Card",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      